import React from 'react';
import {
  FormatterCallbackFunction,
  AxisLabelsFormatterContextObject,
  SeriesLineOptions,
  DrilldownEventObject,
} from 'highcharts';
import GraphPanel from '../GraphPanel/GraphPanel';
import EDLineChart from '../../../../../BaseComponents/Charts/LineChart/EDLineChart';

interface IProps {
  title?: string;
  link?: string;
  yAxisLabel: string;
  formater?: FormatterCallbackFunction<AxisLabelsFormatterContextObject>;
  categories: string[];
  series: SeriesLineOptions[];
  drilldownEvent?: (event: DrilldownEventObject) => void;
}

class LineChartPanel extends React.PureComponent<IProps> {
  render() {
    return (
      <GraphPanel type="line" title={this.props.title} link={this.props.link}>
        <EDLineChart
          yAxisLabel="Värde - kr"
          categories={this.props.categories}
          series={this.props.series}
          drilldownEvent={this.props.drilldownEvent}
          formater={this.props.formater}
        />
      </GraphPanel>
    );
  }
}

export default LineChartPanel;
